import React from "react";
import { Bar, Doughnut, Line } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale, // For category scale (x-axis)
  LinearScale,   // For linear scale (y-axis)
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Register the necessary components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const baseOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        usePointStyle: true,
        boxWidth: 8,
      },
    },
  },
};

const DashboardLineChart = ({ chartData }) => {
  // Check if chartData exists and has datasets
  const hasData = chartData?.datasets?.length > 0 && chartData.datasets[0].data.length > 0;
  

  const options = {
    ...baseOptions,
    tension: 0.4,
    scales: {
      x: {
        border: {
          display: false,
        },
        grid: {
          display: false,
        },
        ticks: {
          color: "black",
          // Show x-axis ticks only if data exists
          display: hasData,
        },
      },
      y: {
        beginAtZero: true,
        border: {
          display: false,
        },
        grid: {
          display: false,
        },
        ticks: {
          callback: function (label) {
            // Use the actual chart data for y-axis labels
            if (!hasData) return null;
            return `₦${label}k`;
          },
          color: "black",
          // Show y-axis ticks only if data exists
          display: hasData,
        },
      },
    },
    plugins: {
      ...baseOptions.plugins,
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };

  return (
    <div className="dashboard-chart">
      {/* Conditionally render the chart based on data presence */}
      {hasData ? (
        <Line options={options} data={chartData} />
      ) : (
        <div style={{
          minHeight: "40vh", 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center",
          marginTop: "-8vh"
        }}>No data available</div>
      )}
    </div>
  );
};

export const DashboardBarChart = ({ chartData }) => {
  const hasData = chartData?.datasets?.some((dataset) => dataset.data?.length > 0);

  return (
    <div className="dashboard-chart dashboard-chart--compact">
      {hasData ? <Bar options={baseOptions} data={chartData} /> : <div className="dashboard-chart__empty">No data available</div>}
    </div>
  );
};

export const DashboardDoughnutChart = ({ chartData }) => {
  const hasData = chartData?.datasets?.some((dataset) => dataset.data?.length > 0);

  return (
    <div className="dashboard-chart dashboard-chart--compact">
      {hasData ? <Doughnut options={baseOptions} data={chartData} /> : <div className="dashboard-chart__empty">No data available</div>}
    </div>
  );
};

export default DashboardLineChart;
